import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Animation } from '../common/Container.jsx';

function TextComponent(props) {
    let style = props.style ? { ...props.style } : {};
    let animation, displayText;
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            Block.mapStyleConfigProps(style, props.blockConfig.block, (propName, propValue) => {
                switch (propName) {
                    case 'displayText':
                        displayText = propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.container) {
            Block.mapStyleConfigProps(style, props.blockConfig.container, (propName, propValue) => {
                switch (propName) {
                    case 'animation':
                        animation = propValue;
                        return true;
                }
            });
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, { alignment: 'textAlign' });
    if (layoutStyles.containerStyle && layoutStyles.containerStyle.maxWidth) {
        layoutStyles.containerStyle.width = '100%';
    }
    let className = 'richText';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    if (props.inPopup) {
        className += ' popup__content';
    }
    let content;
    if (!displayText || displayText.length == 0) {
        content = <div className={className} style={layoutStyles.style}><EmptyPlaceholder /></div>
    } else if (displayText.indexOf('raw-html-embed') >= 0) {
        content = <div className={className} dangerouslySetInnerHTML={{ __html: displayText }} style={layoutStyles.style} />
    } else {
        content = <div className={className} style={layoutStyles.style}><div dangerouslySetInnerHTML={{ __html: displayText }} /></div>
    }
    switch (animation) {
        case '1':
            content = <Animation builder={props.builder}>{content}</Animation>
            break;
    }
    if (layoutStyles.containerStyle) {
        let className;
        if (!props.inCell) {
            className = 'cont--kit__wrapper';
        }
        content = <div className={className} style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
export default { Component: TextComponent };